import {
  FETCH_SITE_SETTINGS,
  FETCH_SITE_SETTINGS_SUCCESS,
  FETCH_SITE_SETTINGS_FAILED,
  UPDATE_USER_CREDITS,
  UPDATE_USER_CONTACT_INFO,
  UPDATE_TABLE_COLUMNS,
  UPDATE_MEMBER_PAUSE_STATUS
} from "../actions/actionTypes";

const initialState = {
  isLoading: true,
  site_settings: null,
  memData: null,
  dashboard_articles: null,
  plan: null,
  error: false,
  total_available_credits:0,
  contact_info:null,
  property_table_columns: {
    // "date": "Sales Date",
    // "price": "Sales Price",
    build: "Year built",
    // "square": "square",
    property_type: "Property Types",
    owner: "Name",
    contact: "Contact Info",
    // "zonedcodelocal": "Zoning",
    // "mortgage1amount": "Mortgage Amount",
    // "taxyearassessed": "Tax Year",
    // "taxassessedvaluetotal": "Tax Price",
  }
};

export default function (state = initialState, { type, payload }) {
  switch (type) {
    case FETCH_SITE_SETTINGS:
      return {
        ...state,
        isLoading: true,
        site_settings: null,
        memData: null
      };
    case UPDATE_TABLE_COLUMNS:
      return {
        ...state,
        property_table_columns: payload,
      };
    case FETCH_SITE_SETTINGS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        site_settings: payload.site_settings,
        memData: payload.member,
        total_available_credits:payload?.member?.total_available_credits > 0 ? payload?.member?.total_available_credits : 0
      };
    case FETCH_SITE_SETTINGS_FAILED:
      return {
        ...state,
        isLoading: false,
        error: payload
      };
    case UPDATE_USER_CREDITS:
      return {
        ...state,
        total_available_credits: payload
      };
    case UPDATE_USER_CONTACT_INFO:
      return {
        ...state,
        contact_info: payload
      };
    case UPDATE_MEMBER_PAUSE_STATUS: {
      const status = payload?.status ?? payload;
      const accessUntil = payload?.access_until ?? null;
      const pauseFee = payload?.pause_fee ?? null;
      if (!state.site_settings) return state;
      return {
        ...state,
        site_settings: {
          ...state.site_settings,
          member: {
            ...(state.site_settings.member || {}),
            mem_pause_status: status,
            mem_pause_access_until: accessUntil,
            mem_pause_fee: pauseFee,
          },
        },
        memData: state.memData
          ? {
              ...state.memData,
              mem_pause_status: status,
              mem_pause_access_until: accessUntil,
              mem_pause_fee: pauseFee,
            }
          : state.memData,
      };
    }
    default:
      return state;
  }
}
